import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { suppressionListsNroHeading, suppressionListsPageNameForTracking } from "../../../suppressionListsNavCopy";

const EditSuppressionRule = lazy(() =>
  import("@scenes/SuppressionLists/components/EditSuppressionRule").then((module) => ({
    default: module.EditSuppressionRule,
  }))
);

export const suppressionRuleDetailsNRO: NavigationRoutingObject = {
  Component: EditSuppressionRule,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: suppressionListsNroHeading,
  pageNameForTracking: suppressionListsPageNameForTracking,
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("suppression_rules") && hasPermission("appGroup", { permission: "viewSegments" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/suppression_lists/:appGroupId",
};
